import { useTranslation } from "react-i18next";
import { FilterTableWrapper } from "../../../components/table/BetterFilterTable/BetterFilterTable";
import LoaderWrapper from "../../../components/wrapper/LoaderWrapper";
import { useProductAgreements } from "../../../services/agreementsService";
import DateService from "../../../services/dateService";
import { getLocalizedProperty } from "../../../utils";
import { AgreementPassportButton } from "../../AgreementsPage/AgreementPassportDialog/AgreementPassportButton";
import { AgreementStatusText } from "../../AgreementsPage/AgreementStatusText";

export const ProductPassportAgreementsTable = (props) => {
    const { productId } = props;
    const { t } = useTranslation();
    const { data: agreements, isLoading } = useProductAgreements(productId);

    return (
        <LoaderWrapper showLoader={isLoading}>
            <FilterTableWrapper
                data={agreements?.results || []}
                filtersOpts={{ hideFiltersIconCol: true }}
                fieldsConfig={[
                    {
                        name: "agreement_nr",
                        getValueCallback: (rowData) => rowData.agreement_nr,
                        label: t("table.agreements.agreementNr"),
                    },
                    {
                        name: "agreement_kind",
                        getValueCallback: (rowData) =>
                            getLocalizedProperty(rowData.agreement_kind, "agrekind_name") || "-",
                        label: t("table.agreements.agreementKind"),
                    },
                    {
                        name: "created",
                        getValueCallback: (rowData) =>
                            rowData.created
                                ? DateService.convertDatetimeFromBackendToFormatYYYYMMDD(
                                      rowData.created,
                                  )
                                : "",
                        label: t("table.agreements.created"),
                    },
                    {
                        getValueCallback: (rowData) =>
                            rowData.shares
                                .flatMap((s) => s.customers)
                                .map((c) => c.company 
                                                ? c.company.name_short 
                                                : `${c.person?.name || ""} ${c.person?.surname}`.trim())
                                .filter(Boolean)
                                .join("\n"),
                        label: t("table.agreements.customers"),
                    },
                    {
                        name: "agreement_status",
                        getValueCallback: (rowData) => (
                            <AgreementStatusText status={rowData.agreement_status} />
                        ),
                        label: t("table.agreements.status"),
                    },
                    {
                        getValueCallback: (rowData) => (
                            <AgreementPassportButton agreement={rowData} />
                        ),
                        label: t("table.agreements.passport"),
                    },
                ]}
            />
        </LoaderWrapper>
    );
};
